import { defineStore } from "pinia";
import { useControlPanelMenuStore } from "./controlpanelMenuStore";

export const useContorlPermissionStore = defineStore({
  id: "controlPanelPermission",
  state: () => ({
    allowedPaths: [],
    isInitialized: false,
  }),
  actions: {
    async initialize() {
      try {
        const menuStore = useControlPanelMenuStore();
        const menuItems = await menuStore.fetchMenuData();
        this.updateAllowedPaths(menuItems);
        this.isInitialized = true;
      } catch (error) {
        console.error(
          "Failed to initialize control panel allowed paths:",
          error
        );
        throw error;
      }
    },

    updateAllowedPaths(transformedMenuItems) {
      // Flat structure — no children, simple map
      this.allowedPaths = transformedMenuItems
        .filter((item) => item.path)
        .map((item) => item.path.toLowerCase());
    },

    isControlPanelPathAllowed(path) {
      const normalizedPath = path.toLowerCase().replace(/\/$/, "");
      return this.allowedPaths.some((allowedPath) =>
        normalizedPath.startsWith(allowedPath)
      );
    },
  },
});